<template>
	<div style="display: contents;">
		<template v-if="buttonComponent == 'v-btn'">
			<v-tooltip top>
				<template v-slot:activator="{ on: tooltip, attrs }">
					<v-btn
						v-on="{ ...tooltip }"
						v-bind="attrs"
						:disabled="disabled"
						:fab="btnParams.fab ? btnParams.fab : false"
						:icon="btnParams.fab ? false : true"
						:small="btnParams.small ? true : false"
						:color="btnParams.button_color ? btnParams.button_color : ''"
						@click="openDialog()">
						<v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24">{{ btnParams.icon ? btnParams.icon : 'web' }}</v-icon>
					</v-btn>
				</template>
				<span>{{ button.tooltip ? button.tooltip : 'Converti in Progetto' }}</span>
			</v-tooltip>
		</template>

		<v-list-item v-else-if="buttonComponent == 'v-list-item'"
			dense
			:disabled="disabled"
			@click.stop="openDialog()"
			ripple>
			<v-list-item-icon>
				<v-icon style="font-size: 18px">{{ btnParams.icon ? btnParams.icon : 'web' }}</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>{{ button.tooltip ? button.tooltip : 'Converti in Progetto' }}</v-list-item-title>
			</v-list-item-content>
		</v-list-item>

		<v-dialog v-model="show" max-width="700" persistent class="round-card" scrollable>
			<v-card class="background-2 round-card">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3">Converti {{ $trans('opportunity') }} in {{ $trans('project') }}</p>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="px-1 pb-1">
					<v-container v-if="show" fluid class="px-6 pt-6">
						<div class="pt-2 body-2 pb-2">
							Verrà creato un nuovo {{ $trans('project') }} a partire da questa {{ $trans('opportunity') }}.
							L'{{ $trans('opportunity') }} sarà impostata come <strong>accettata</strong> e i preventivi
							accettati, da fatturare e fatturati verranno collegati al nuovo {{ $trans('project') }}.
						</div>

						<p class="body-2 font-weight-medium mb-1 mt-4">Allegati e cartelle dell'{{ $trans('opportunity') }}</p>
						<p class="caption grey--text mb-1">La struttura delle cartelle viene mantenuta così com'è sul {{ $trans('project') }}.</p>
						<v-radio-group v-model="attachments_action" class="mt-0" hide-details>
							<v-radio value="copy">
								<template v-slot:label>
									<span>Copia allegati e cartelle sul {{ $trans('project') }} <span class="grey--text">(mantiene gli originali sull'{{ $trans('opportunity') }})</span></span>
								</template>
							</v-radio>
							<v-radio value="move">
								<template v-slot:label>
									<span>Sposta allegati e cartelle sul {{ $trans('project') }} <span class="grey--text">(li rimuove dall'{{ $trans('opportunity') }})</span></span>
								</template>
							</v-radio>
							<v-radio value="none">
								<template v-slot:label>
									<span>Non trasferire allegati e cartelle</span>
								</template>
							</v-radio>
						</v-radio-group>
					</v-container>
				</v-card-text>

				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="info" :disabled="loading" @click.native.stop="closeDialog()">Annulla</v-btn>
					<v-btn text color="success" :loading="loading" :disabled="loading" @click.native.stop="convert()">Converti</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>

	export default {
		name: 'convert-opportunity-to-project-component',
		components: {
		},
		props: {
			button: Object,
			buttonComponent: {type: String, default: 'v-btn'},
			id: Number,
			model: Object,
			modelDef: String,
			params: Object,
			disabled: Boolean
		},

		data() {
			return {
				show: false,
				loading: false,
				attachments_action: 'copy'
			}
		},

		computed: {
			btnParams() {
				return this.button && this.button.params ? this.button.params : {}
			}
		},

		methods: {

			openDialog() {
				this.attachments_action = 'copy'
				this.show = true
			},

			closeDialog() {
				this.show = false
			},

			convert() {
				let objectData = {
					attachments_action: this.attachments_action
				}

				this.loading = true
				this.axios.post('opportunities-projects/' + this.id, objectData).then(response => {
					const projectId = response.data.project_id || response.data.id

					// Senza id non si può navigare: avvisa invece di lasciare l'utente
					// sulla stessa pagina con un messaggio di successo e nessun effetto.
					this.$store.commit('setSnackbar', {
						timeout: projectId ? 6000 : 8000,
						text: projectId
							? (response.data.message || 'Opportunità convertita in progetto con successo')
							: 'Progetto creato, ma non è stato possibile aprirlo automaticamente: cercalo nell\'elenco progetti.',
						value: true,
						color: projectId ? 'success' : 'warning'
					})

					this.loading = false
					this.closeDialog()

					if (projectId) {
						this.$eventBusUtility.goTo(this.$router, this.button.route || 'projects-show', projectId)
					} else {
						this.$emit('refresh')
					}
				}, error => {
					this.loading = false
					this.$store.commit('setSnackbar', {
						timeout: 6000,
						text: (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'Errore durante la conversione in progetto',
						value: true,
						color: 'error'
					})
				})
			}

		},
	}
</script>
